import { useTranslation } from "react-i18next";
import Bredcrumb from "../HomeMain/Bredcrumb";
import About from "../HomeMain/About";
import Appointment from "../HomeMain/Appointment";
import Testimonial from "../HomeMain/Testimonial";
import Faq from "../HomeMain/Faq";

const Main = () => {
  const { t } = useTranslation();

  return (
    <>
      <Bredcrumb title={t('pages.about.title')} subtitle={t('pages.about.subtitle')} />
      <About />
      <Appointment />
      <Faq />
      <Testimonial />
    </>
  );
};

export default Main;
